export enum RouteName {
  Login = "Connexion",
  Register = "register",
  Agenda = "Agenda",
  Cabinets = "Cabinets",
  CabinetsRoot = "CabinetsRoot",
  CabinetsZoom = "Cabinets Zoom",
  FeuilleVerte = "Feuille verte",
  Home = "Centre de contrôle",
  HomeFollawed = "Centre de contrôle - Follawed",
  JORFRoot = "Journal Officiel root",
  JORF = "Journal Officiel",
  JORFFollawed = "Journal Officiel - Follawed",
  JORFZoom = "Zoom Journal Officiel",
  LegislativeRoot = "LegislativeRoot",
  LegislativeFiles = "Dossiers législatifs",
  LegislativeFilesFollawed = "Dossiers législatifs - follawed",
  LegislativeZoom = "LegislativeZoom",
  LegislativeZoomTimeline = "Zoom Follawed Dossiers Législatifs - Navette parlementaire",
  LiveRoot = "Le Direct",
  LiveEnSeance = "LiveEnSeance",
  LiveEliasse = "LiveEliasse",
  Lobbies = "Lobbies",
  LobbiesFollawedRoot = "Lobbies Follawed root",
  LobbiesFollawed = "Lobbies Follawed - Vos follaw",
  LobbiesFollawedNews = "Lobbies Follawed - Leurs actualités",
  LobbiesZoomReport = "Zoom Compte-rendu d'un Lobby",
  LobbiesZoomQuestion = "Zoom Question d'un Lobby",
  LobbiesZoomStaff = "Lobby Zoom - Dirigeants et personnel",
  LobbiesZoomClient = "Lobby Zoom - Clients",
  LobbiesZoomActivitiesLobbying = "Lobby Activités - Lobbying",
  LobbiesZoomActivityPublications = "Lobby Activités - Publications",
  LobbiesZoomActivities = "Lobby Activités - Default",
  LobbiesZoomActivitiesRoot = "Lobby Zoom - Activités",
  LobbiesZoomNews = "Lobby Zoom - Actualités",
  LobbiesZoom = "Lobby Zoom - Informations Globales",
  LobbiesZoomRoot = "Lobby Zoom",
  Dashboard = "Veilles",
  NewsRoot = "Communiqués root",
  News = "Communiqués",
  NewsZoom = "Zoom Communiqués",
  NotificationRoot = "Alerting",
  NotificationDigest = "Alerting - Récapitulatifs",
  NotificationAlerts = "Alerting - Alertes",
  NotFound = "Non Trouvé",
  Nominations = "Nominations",
  Inscription = "Inscription",
  OrdreDuJourRoot = "Ordre du jour",
  OrdreDuJour = "Ordre du jour - Sénat",
  OnboardingRoot = "Onboarding",
  OnboardingSetupDashboard = "Onboarding - first dashboard",
  OnboardingSetupAlerts = "Onboarding - first alerts",
  OnboardingDone = "Onboarding - done",
  PetitionsRoot = "Pétitions root",
  Petitions = "Pétitions",
  PetitionsFollawed = "Pétitions - Follawed",
  PetitionZoom = "Zoom petitions",
  UserSettingsRoot = "Paramètres utilisateur",
  UserSettingsAccount = "Paramètres utilisateur - Compte",
  UserSettingsSubscription = "Paramètres utilisateur - Abonnement",
  UserSettingsNotifications = "Paramètres utilisateur - Notifications",
  Root = "Structure",
  Forbidden = "403",
  Amendements = "Amendements",
  AmendementsZoom = "Zoom amendements",
  AmendementsFollawed = "Amendements - Follawed",
  Articles = "Articles",
  AmendementsRoot = "AmendementsRoot",
  CabinetMeeting = "Conseil des Ministres",
  LobbiesRoot = "LobbiesRoot",
  LegislativeTimelineInitialText = "Text Initial",
  LegislativeZoomTimelineGlobal = "Zoom Follawed Dossiers Législatifs - Informations globales",
  LegislativeZoomAmendments = "Zoom Follawed Dossiers Législatifs - Amendements",
  LegislativeZoomAgenda = "Zoom Follawed Dossiers Législatifs - Agenda et comptes-rendus",
  LegislativeZoomPublications = "Zoom Follawed Dossiers Législatifs - Social media",
  LegislativeZoomExposeDesMotifs = "Zoom Follawed Dossiers Législatifs - Exposé des motifs",
  LegislativeZoomAdditionalInfos = "Zoom Follawed Dossiers Législatifs - Infos supplémentaires",
  LobbiesFollawedActivities = "Lobbies Follawed - Leurs activités",
  LobbiesFollawedActivitiesLobbying = "Lobbies Follawed - Lobbying",
  LobbiesFollawedActivitiesPublications = "Lobbies Follawed - Publications",
  ParliamentaryOverview = "Overview parlementaire",
  PRMNational = "National",
  PRMNationalRoot = "PRMNationalRoot",
  PRMNationalFollawedRoot = "PRMNationalFollawedRoot",
  PRMNationalFollawed = "PRM National Follawed - Vos follaw",
  PRMNationalFollawedNews = "PRM National Follawed - Leurs actualités",
  PRMNationalFollawedActivity = "PRM National Follawed - Leurs activités",
  PRMNationalZoomRoot = "PRM National Zoom - root",
  PRMNationalZoomGeneralInfo = "PRM National Zoom - Informations générales",
  PRMNationalZoomBiography = "PRM National Zoom - Biographie",
  PRMNationalZoomNews = "PRM National Zoom - Actualités",
  PRMNationalZoomContact = "PRM National Zoom - Contact",
  PRMNationalZoomQuestion = "Zoom Question d'un PRM",
  PRMNationalZoomAmendment = "Zoom Amendement d'un PRM",
  PRMNationalZoomActivity = "PRM National Zoom - Activités",
  PRMRegionalContact = "PRM Régional Zoom - Contact",
  PRMRegionalZoomActivity = "PRM Régional Zoom - Activités",
  PRMRegionalZoomNews = "PRM Régional Zoom - Actualités",
  PRMRegionalZoomBiography = "PRM Régional Zoom - Biographie",
  PRMRegionalZoomGeneralInfo = "PRM Régional Zoom - Informations générales",
  PRMRegionalZoomRoot = "PRM Régional Zoom",
  PRMRegionalFollawedActivity = "PRM Régional Follawed - Leurs activités",
  PRMRegionalFollawedNews = "PRM Régional Follawed - Leurs actualités",
  PRMRegionalFollawed = "PRM Régional Follawed - Vos follaw",
  PRMRegionalFollawedRoot = "PRM Régional Follawed - root",
  PRMRegional = "Régional, départemental & local",
  PRMRegionalRoot = "PRM Régional - root",
  CR = "Zoom Comptes-rendus",
  ReportZoom = "Zoom rapport",
  Report = "Comptes-rendus et rapports",
  ReportRoot = "Comptes-rendus et rapports root",
  Questions = "Questions",
  QuestionsFollawed = "Questions - Follawed",
  QuestionsZoom = "Zoom question",
  SocialMediaLocked = "Réseaux vérouillés",
  SocialMediaOverview = "Overview",
  SocialMediaPublicationsFollawed = "Publications - Follawed",
  SocialMediaPublications = "Publications",
  TranscriptionsRoot = "Transcriptions",
  Transcriptions = "Transcriptions list",
  TranscriptionZoom = "Zoom Transcription",
  StakeholderSocietalMap = "Parties Prenantes - Cartographie Sociétale",
  StakeholderPoliticalMap = "Parties Prenantes - Cartographie Politique",
  StakeholderRankingFollawed = "Parties Prenantes - Follawed",
  StakeholderRankingList = "Parties Prenantes - Ranking List",
  StakeholderRanking = "Parties Prenantes - Ranking",
  StakeholderZommMentions = "Zoom Partie Prenante - Mentions",
  StakeholderZoomPublications = "Zoom Partie Prenante - Publications",
  StakeholderZoomPreview = "Zoom Partie Prenante - Aperçu",
  StakeholderZoom = "Zoom Partie Prenante",
  Stakeholders = "Parties Prenantes - Default",
  StakeholdersRoot = "Parties Prenantes",
}
